import { MyDigitsActionTypes } from "./../actions/index.model";
import { takeLatest, call, put, all, fork, select } from "redux-saga/effects";
import { updateApiCallStatus } from "./../../actions";
import {
  updateUserInfo,
  updateLineDetails,
  updatePairDetails,
} from "../actions";
import { LineDetails, Lines, UserDetails } from "../reducers/index.model";
import SDK from "./../../sdk";
import {
  setAttempts,
  setError,
  setLoader,
} from "app/common/NumberCard/action/pairedLinesAction";
import { successSavingName, updatedNameId } from "app/common/NumberCard/action";
import { RootState } from "app/reducers";
import { getPairedLine } from "app/LineDelve/actions";
import { extractmsisdn, xmlPayload } from "app/utils/helper";
import { Category } from "app/utils/categories";
import { EncryptJSON, EncryptString } from "app/utils/crypto";
import XMLParser from "react-xml-parser";
const state = (state: RootState) => state;

const pairedDeviceMsg=process.env.REACT_APP_PAIRED_DEVICE_MSG?process.env.REACT_APP_PAIRED_DEVICE_MSG:"msg.pc.t-mobile.com";

function* getLineDetails() {
  yield takeLatest(MyDigitsActionTypes.GET_LINE_DETAILS, GetLineDetails);
}

function* unpairLine() {
  yield takeLatest(MyDigitsActionTypes.UNPAIR_LINE, UnpairLine);
}

function* userLogout() {
  yield takeLatest(MyDigitsActionTypes.USER_LOGOUT, logout);
}

export function* UnpairLine(action: any): any {
  try {
    const stateData: RootState = yield select(state);
    const selectedDeviceId = stateData.allLines.selectedLineDetails.id;

    const apiStatusData = stateData.app.apiCallsStatus.find(
      (item) => item.module === MyDigitsActionTypes.UNPAIR_LINE
    );

    let noOfAttempts: number = 0;
    if (apiStatusData && apiStatusData?.noOfAttempts) {
      noOfAttempts = apiStatusData.noOfAttempts;
    }

    yield put(
      updateApiCallStatus({
        status: "pending",
        module: MyDigitsActionTypes.UNPAIR_LINE,
        noOfAttempts: noOfAttempts + 1,
      })
    );
    let query = "";
    const msisdn =
      action.data.type === "delveDetails"
        ? selectedDeviceId
        : action.data.msisdn;
    const linePairRes = yield call(SDK.getLinePair, action.data.msisdn);
    var xml = new XMLParser().parseFromString(linePairRes);
    const pairedDevice: any = extractmsisdn(
      xml.getElementsByTagName("unbarred-multisim-id")[0].value
    );
    const currentDevice = extractmsisdn(xml.getElementsByTagName("sipUri"));
    query = "";
    //const pairedDeviceMsg=process.env.REACT_APP_PAIRED_DEVICE_MSG?process.env.REACT_APP_PAIRED_DEVICE_MSG:"msg.pc.t-mobile.com";
    if (Array.isArray(currentDevice) && currentDevice.length > 1) {
      // currentDevice.forEach((device: any) => {
      //   if (device !== action.data.msisdn) {
      //     query =
      //       query +
      //       `<multisim-item-id><sipUri>sip:${device}@${pairedDeviceMsg}</sipUri></multisim-item-id>`;
      //   }
      // });
      query=getpairLineQuery(currentDevice,action,query);
      const xmlPayloadData = xmlPayload(pairedDevice, query);
      const res = yield call(SDK.pairLine, pairedDevice, xmlPayloadData);
      if (res && res.status === 400) {
        throw new Error("unpairing line failed");
      }
    } else {
      const payload = `${msisdn}`;
      const unpairRes = yield call(SDK.unpairLine, payload);
      if (unpairRes && unpairRes.status === 400) {
        throw new Error("unpairing line failed");
      }
    }

    if (action.data.type === "delveDetails") {
      yield put(getPairedLine({ msisdn: msisdn }));
    }

    yield put(
      updatePairDetails({ deviceNumber: action.data.msisdn, type: "unpair" })
    );
    yield put(updatedNameId({ id: action.data.msisdn }));
    yield put(
      successSavingName({ message: "You have successfully unpaired the line" })
    );
    yield put(
      updateApiCallStatus({
        status: "success",
        module: MyDigitsActionTypes.UNPAIR_LINE,
        noOfAttempts: 0,
      })
    );
  } catch (e) {
    yield put(
      updateApiCallStatus({
        status: "error",
        module: MyDigitsActionTypes.UNPAIR_LINE,
      })
    );
  }
}

function getpairLineQuery(currentDevice:any,action:any,query:any){
  currentDevice.forEach((device: any) => {
    if (device !== action.data.msisdn) {
      query =
        query +
        `<multisim-item-id><sipUri>sip:${device}@${pairedDeviceMsg}</sipUri></multisim-item-id>`;
    }
  });

  return query;
}

function* pairLine() {
  yield takeLatest(MyDigitsActionTypes.PAIR_LINE, PairLine);
}

export function* PairLine(action: any): any {
  try {
    const stateData: RootState = yield select(state);

    const apiStatusData = stateData.app.apiCallsStatus.find(
      (item) => item.module === MyDigitsActionTypes.PAIR_LINE
    );

    let noOfAttempts: number = 0;
    if (apiStatusData && apiStatusData?.noOfAttempts) {
      noOfAttempts = apiStatusData.noOfAttempts;
    }

    yield put(
      updateApiCallStatus({
        status: "pending",
        module: MyDigitsActionTypes.PAIR_LINE,
        noOfAttempts: noOfAttempts + 1,
      })
    );
    yield put(setLoader(true));
    yield put(setAttempts(stateData.pairedLine.noofAttempts + 1));
    const deviceNumber = `${action.data.deviceNumber}`;
    const pairRes = yield call(SDK.getLinePair, action.data.pairedDevice);
    let query = "";
    if (pairRes) {
      var xml = new XMLParser().parseFromString(pairRes);
      const barredListNode = xml.getElementsByTagName(
        "barred-multisim-id-list"
      );
      if (barredListNode.length > 0) {
        const pairedList = extractmsisdn(
          barredListNode[0].getElementsByTagName("sipUri")
        );
        if (
          Array.isArray(pairedList) &&
          pairedList.includes(action.data.deviceNumber)
        ) {
          yield put(
            updateApiCallStatus({
              status: "already_paired",
              module: MyDigitsActionTypes.PAIR_LINE,
              noOfAttempts: 0,
            })
          );
          return;
        }
      }
      // console.log('barred',barredXML, extractmsisdn(barredXML.getElementsByTagName("sipUri")))
      const pairedDevice = extractmsisdn(xml.getElementsByTagName("sipUri"));
      if (Array.isArray(pairedDevice)) {
        pairedDevice.forEach((device: any) => {
          query =
            query +
            `<multisim-item-id><sipUri>sip:${device}@${pairedDeviceMsg}</sipUri></multisim-item-id>`;
        });
      } else {
        query =
          query +
          `<multisim-item-id><sipUri>sip:${pairedDevice}@${pairedDeviceMsg}</sipUri></multisim-item-id>`;
      }
    }
    query =
      query +
      `<multisim-item-id><sipUri>sip:${action.data.deviceNumber}@${pairedDeviceMsg}</sipUri></multisim-item-id>`;
    const xmlPayloadData = xmlPayload(action.data.pairedDevice, query);
    const res = yield call(SDK.pairLine, deviceNumber, xmlPayloadData);

    if (res && res.status === 400) {
      throw new Error("pairing line failed");
    }

    yield put(setLoader(false));
    yield put(
      updateApiCallStatus({
        status: "success",
        module: MyDigitsActionTypes.PAIR_LINE,
        noOfAttempts: 0,
      })
    );
    yield put(setAttempts(0));
    yield put(
      updatePairDetails({
        pairedDevice: action.data.pairedDevice,
        deviceNumber: action.data.deviceNumber,
        type: "pair",
      })
    );
    yield put(updatedNameId({ id: action.data.deviceNumber }));
    yield put(
      successSavingName({ message: "You have successfully paired the line" })
    );
  } catch (e) {
    yield put(
      updateApiCallStatus({
        status: "error",
        module: MyDigitsActionTypes.PAIR_LINE,
      })
    );
    yield put(setError("PAIR_ERROR"));
  }
}

export function* GetLineDetails(): any {
  yield put(
    updateApiCallStatus({
      status: "pending",
      module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
    })
  );
  const userInfo = yield call(SDK.getUserInfo);

  if (!userInfo.errors) {
    const userDetails: UserDetails = userInfo?.TMO_ID_profile;
    if (userInfo?.associated_lines?.lines != null) {
      const userMsisdn =
        userInfo.associated_lines.lines.length > 0
          ? userInfo?.associated_lines?.lines[0].MSISDN
          : 0;
      sessionStorage.setItem("userMsisdn", EncryptString(userMsisdn));
      sessionStorage.setItem("userDetails", EncryptJSON(userDetails));
      yield put(updateUserInfo(userDetails));
      const lines_details = yield call(SDK.getUserLines);
      if (
        lines_details &&
        !lines_details.errors &&
        lines_details.lines_details.length > 0
      ) {
        lines_details.lines_details
          .filter((obj: any) => obj.id === Category.wearblesID)[0]
          .lines.forEach((obj: any) => {
            obj["isPared"] = false;
            obj["pairedDevice"] = "";
          });
        const linesData = lines_details.lines_details;
        const wearblesData = linesData.filter(
          (obj: any) => obj.id === Category.wearblesID
        );
        if (wearblesData.length > 0 && wearblesData[0].lines.length > 0) {
          // const query = `${wearblesData[0].lines[0].msisdn}`
          // const query = `14254598905`
          try {
            const responses = yield all(
              wearblesData[0].lines.map((line: any) =>
                call(SDK.getLinePair, line.msisdn)
              )
            );
            responses.forEach((res: any) => {
              if (
                res &&
                res !== null &&
                res !== "" &&
                typeof res === "string"
              ) {
                var xml = new XMLParser().parseFromString(res);
                const pairedDevice = extractmsisdn(
                  xml.getElementsByTagName("unbarred-multisim-id")[0].value
                );
                const currentDevice = extractmsisdn(
                  xml.getElementsByTagName("sipUri")
                );
                lines_details.lines_details
                  .filter((obj: LineDetails) => obj.id === Category.wearblesID)
                  .map((lineDetails: LineDetails) => lineDetails.lines)
                  .forEach((lines: Lines[]) =>
                    lines.forEach((obj: any) => {
                      if (Array.isArray(currentDevice)) {
                        currentDevice.forEach((device: any) => {
                          if (obj.MSISDN === device) {
                            obj["isPared"] = true;
                            obj["pairedDevice"] = pairedDevice;
                          }
                        });
                      } else {
                        if (obj.MSISDN === currentDevice) {
                          obj["isPared"] = true;
                          obj["pairedDevice"] = pairedDevice;
                        }
                      }
                    })
                  );
              }
            });
          } catch (e) {
            console.log("line pair issue", e);
          }
        }
        yield put(
          updateLineDetails(lines_details ? lines_details.lines_details : [])
        );
        yield put(
          updateApiCallStatus({
            status: "success",
            module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
          })
        );
        yield put(
          updateApiCallStatus({
            status: "final",
            module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
          })
        );
      } else {
        yield put(updateLineDetails([]));
        yield put(
          updateApiCallStatus({
            status: "error",
            module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
          })
        );
      }
    } else {
      yield put(updateLineDetails([]));
      yield put(
        updateApiCallStatus({
          status: "error",
          module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
        })
      );
    }
  } else {
    yield put(updateLineDetails([]));
    yield put(
      updateApiCallStatus({
        status: "error",
        module: MyDigitsActionTypes.LINE_DETAILS_STATUS,
      })
    );
  }
}

export function* logout(): any {
  yield put(
    updateApiCallStatus({
      status: "pending",
      module: MyDigitsActionTypes.USER_LOGOUT,
    })
  );
  yield call(SDK.logout);
  yield put(
    updateApiCallStatus({
      status: "final",
      module: MyDigitsActionTypes.USER_LOGOUT,
    })
  );
}

export default function* lineDetailsSaga() {
  yield all([
    fork(getLineDetails),
    fork(unpairLine),
    fork(pairLine),
    fork(userLogout),
  ]);
}
